import { ProjectDispatchedRoutesDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';

export default ({ store }: ProjectDispatchedRoutesDtoModelType) => {
  const appStore = getAppRoot(store);
  const projectId = appStore.ui.selectedWorkspace?.id;

  if (projectId) {
    appStore.driverLocation.start(Number(projectId))
      .catch(() => {
        console.error('Failed to update driver location store.');
      });
  }
};
